import type {Theme} from '@emotion/react';

interface VariablesProps {
    theme: Theme;
}

/**
 * Generates CSS custom properties for the base state of text input components.
 *
 * @param {VariablesProps} props Object containing the theme.
 * @returns {string} CSS custom properties as a string.
 */
export const getBaseVariables = ({theme}: VariablesProps) => `
    --text-input-background-color: ${theme.colors.neutral20};
    --text-input-border-color: ${theme.colors.neutral20};
    --text-input-font-color: ${theme.colors.textPrimary};
    --text-input-placeholder-font-color: ${theme.colors.textSecondary};
    --label-font-color: ${theme.colors.textPrimary};
`;

/**
 * Generates CSS custom properties for the disabled state of text input components.
 *
 * @param {VariablesProps} props Object containing the theme.
 * @returns {string} CSS custom properties as a string.
 */
export const getDisabledVariables = ({theme}: VariablesProps) => `
    --text-input-font-color: ${theme.colors.neutral40};
    --text-input-placeholder-font-color: ${theme.colors.neutral40};
    --label-font-color: ${theme.colors.neutral60};
`;

/**
 * Generates CSS custom properties for the error state of text input components.
 *
 * @param {VariablesProps} props Object containing the theme.
 * @returns {string} CSS custom properties as a string.
 */
export const getErrorVariables = ({theme}: VariablesProps) => `
    --text-input-border-color: ${theme.colors.error};
    --label-font-color: ${theme.colors.textPrimary};
`;

/**
 * Generates CSS custom properties for the focus state of text input components.
 *
 * @param {VariablesProps} props Object containing the theme.
 * @returns {string} CSS custom properties as a string.
 */
export const getFocusVariables = ({theme}: VariablesProps) => `
    --text-input-background-color: ${theme.colors.neutral0};
    --text-input-border-color: ${theme.colors.primary};
    --label-font-color: ${theme.colors.primary};
`;